import React, { useMemo, useState } from 'react';
import { ExistingCard } from '../types/api';

const BRAND_LABELS: Record<ExistingCard['type'], string> = {
  unknown: 'Card',
  visa: 'Visa',
  masterCard: 'Mastercard',
  maestro: 'Maestro',
  amex: 'Amex',
  diners: 'Diners',
  jcb: 'JCB',
  discover: 'Discover',
};

interface ExistingCardListProps {
  cards: ExistingCard[];
  onSelect: (token: string) => void;
  onUseNewCard: () => void;
}

const ExistingCardList: React.FC<ExistingCardListProps> = ({ cards, onSelect, onUseNewCard }) => {
  const sortedCards = useMemo(() => {
    return [...cards].sort((a, b) => (a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1));
  }, [cards]);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleContinue = () => {
    const card = sortedCards[selectedIndex];
    if (card) onSelect(card.token);
  };

  return (
    <div className="flex flex-col gap-4">
      <p className="text-black text-md font-semibold">Choose from an existing card</p>

      <div className="flex flex-col gap-2">
        {sortedCards.map((card, index) => (
          <button
            key={card.token}
            type="button"
            onClick={() => setSelectedIndex(index)}
            className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
              index === selectedIndex
                ? 'border-primary-btn bg-blue-50'
                : 'border-border hover:border-gray-400'
            }`}
          >
            <span
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                index === selectedIndex ? 'border-primary-btn' : 'border-border'
              }`}
            >
              {index === selectedIndex && (
                <span className="w-2.5 h-2.5 rounded-full bg-primary-btn" />
              )}
            </span>

            <div className="flex flex-1 items-center justify-between min-w-0">
              <div className="flex flex-col items-start text-left min-w-0">
                <span className="text-black text-md font-semibold">
                  {BRAND_LABELS[card.type]} **** {card.last4D}
                </span>
                <span className="text-text-disabled text-sm truncate">
                  {card.holder} &middot; Exp {card.expiry}
                </span>
              </div>
              {card.isDefault && (
                <span className="text-xs font-semibold text-primary-btn bg-blue-50 px-2 py-0.5 rounded-full flex-shrink-0">
                  Default
                </span>
              )}
            </div>
          </button>
        ))}
      </div>

      <button onClick={handleContinue} className="btn-primary w-full">
        Continue
      </button>

      <button
        type="button"
        onClick={onUseNewCard}
        className="text-primary-btn text-sm font-semibold hover:underline self-center"
      >
        Use another card
      </button>
    </div>
  );
};

export default ExistingCardList;
